import { Device } from './device.model';

export class DeviceConnectivity {
  public device: Device;
  public status: string;
  public start: Date;
  public end: Date;
}
